/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from 'react';
import usePersistentStore from "../../../persistentStore";
import firebase from 'firebase/app';
import 'firebase/auth';
import * as STATES from "../../../constants/states";
import {useMutation, useQuery} from "@apollo/react-hooks";
import {CREATE_USER, GET_USER} from "../../../database/queries/userQueries";
import {parseFullName} from "parse-full-name";
import {LOGIN} from "../../../database/queries/loginQueries";
import {notify} from "../../../utils/notify";
import {useHistory} from "react-router-dom";
import {amInIFrame, amInPopup, getQueryObj, tellParentURLMessage} from "../../../utils/utils";
import {GET_USER_PREFERENCES} from "../../../database/queries/userPreferences";

const redirectPageKey = 'redirect-page';
const popupParentKey = 'popup-parent-page';

const inIFrame = amInIFrame();
const inPopup = amInPopup();
const queryObj = getQueryObj();

const AuthUser = props => {
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const [raceCondition, setRaceCondition] = useState(false);
    const [login, {error: getUserTokenError, data: getUserTokenData}] = useMutation(LOGIN);
    // const [savePerson, {error: savePersonError, data: savePersonData}] = useMutation(SAVE_PERSON);
    // const [saveOrganization, {
    //     error: saveOrganizationError,
    //     data: saveOrganizationData
    // }] = useMutation(SAVE_ORGANIZATION);
    const history = useHistory();

    const {error: getUserError, refetch: getUserRefetch} = useQuery(GET_USER, {
        skip: true,
        variables: {
            userId: globalPersistentState.authUser ? globalPersistentState.authUser.uid : ''
        },
    });

    const [createUser, {error: createUserError}] = useMutation(CREATE_USER);

    const {refetch: getUserPreferencesRefetch} = useQuery(GET_USER_PREFERENCES, {
        skip: true,
        variables: {domain: 'popup'}
    });

    // useEffect(() => {
    //     if (getUserPreferencesData && getUserPreferencesData.userPreferences && getUserPreferencesData.userPreferences.length > 0) {
    //         const objs = getUserPreferencesData.userPreferences.filter(pObj => pObj.key === 'popupPrefs');
    //         const popupParent = localStorage.getItem(popupParentKey);
    //         if (objs.length > 0) {
    //             const val = objs[0].value;
    //             if (val.length > 0) tellParentURLMessage({userPreferences: JSON.parse(val)}, JSON.parse(popupParent))
    //         }
    //         window.parent.postMessage({action: 'close-window'}, JSON.parse(popupParent));
    //         globalPersistentActions.closePopup();
    //         localStorage.setItem(popupParentKey, null);
    //     }
    // }, [getUserPreferencesData]);

    useEffect(() => {
        if (inPopup) {
            if (queryObj) {
                // console.log('## AuthUser ## setting queryObj', queryObj);
                localStorage.setItem(popupParentKey, JSON.stringify(queryObj.selectionUrl));
                globalPersistentActions.setPopupQueryObj(queryObj);
            } else {
                const okPages = ['/sign-in', '/sign-up'];
                let ok = false;
                for (let o = 0; o < okPages.length; o++) {
                    const okPage = okPages[o];
                    if (document.location.pathname.indexOf(okPage) > -1) ok = true;
                }
                const popupParent = localStorage.getItem(popupParentKey);
                if (!ok && popupParent) {
                    // console.log('## AuthUser ## cleaning up popup cause there is no queryObj');
                    tellParentURLMessage({action: 'close-window'}, JSON.parse(popupParent))
                    // window.parent.postMessage({action: 'close-window'}, JSON.parse(popupParent));
                    globalPersistentActions.closePopup();
                    localStorage.setItem(popupParentKey, null);
                }
            }
        }
    }, [])

    useEffect(() => {
        if (createUserError) notify('createUserError', 'error', createUserError.message);
        if (getUserError) notify('getUserError', 'error', getUserError.message);
        if (getUserTokenError) notify('getUserTokenError', 'error', getUserTokenError.message);
    }, [createUserError, getUserError, getUserTokenError]);

    // ############### FOUND A PENDING MESSAGE FROM LINKEDIN ###############

    // useEffect(() => {
    //     if (savePersonData) {
    //         // console.log('## AuthUser ## savePersonData', savePersonData.savePerson);
    //         globalPersistentActions.setMessage();
    //         // console.log('## AuthUser ## changing history', '/contacts/' + savePersonData.savePerson.contactId);
    //         history.push('/contacts/' + savePersonData.savePerson.contactId);
    //     }
    // }, [savePersonData, history]);

    // useEffect(() => {
    //     if (saveOrganizationData) {
    //         // console.log('## AuthUser ## saveOrganizationData', saveOrganizationData.saveOrganization);
    //         globalPersistentActions.setMessage();
    //         // console.log('## AuthUser ## changing history', '/accounts/' + saveOrganizationData.saveOrganization.accountId);
    //         history.push('/accounts/' + saveOrganizationData.saveOrganization.accountId);
    //     }
    // }, [saveOrganizationData, history]);

    // ############### SIGNING IN ###############

    // Signing in (STEP 1) firebase state changed
    firebase.auth().onAuthStateChanged(authUser => {
        if (globalPersistentState.state === STATES.LOGGING_IN && !globalPersistentState.authUser && !raceCondition) {
            // console.log('## AuthUser ## p');
            // console.log('## AuthUser ## Signing in (STEP 1 - authUser)');
            setRaceCondition(true);

            const u = {
                uid: authUser.uid,
                email: authUser.email,
                displayName: authUser.displayName,
                phoneNumber: authUser.phoneNumber,
                photoUrl: authUser.photoUrl,
                providerId: authUser.providerId,
            };
            globalPersistentActions.setAuthUser(u);
        } else if (globalPersistentState.state === STATES.LOGGING_OUT) {
            // console.log('## AuthUser ## o');
            // console.log('## AuthUser ## Signing out (STEP 1)');
            // console.log('## AuthUser ## firebase.auth().onAuthStateChanged', STATES.LOGGING_OUT, authUser.uid);
            globalPersistentActions.setAuthUser(null);
        }
    });

    // Signing in (STEP 2) go get token
    useEffect(() => {
        if (globalPersistentState.state === STATES.LOGGING_IN && globalPersistentState.authUser && !globalPersistentState.token) {
            // console.log('## AuthUser ## q');
            // console.log('## AuthUser ## Signing in (STEP 2 - retrieving token)');
            login({
                variables: {
                    uid: globalPersistentState.authUser.uid
                }
            }).catch((e) => {
                notify('getToken', 'error', e.message);
            })
        }
    }, [globalPersistentState.authUser, globalPersistentState.state, globalPersistentState.token, login]);

    // Signing in (STEP 3) received token
    useEffect(() => {
        setRaceCondition(false);
        if (globalPersistentState.state === STATES.LOGGING_IN && globalPersistentState.authUser && getUserTokenData) {
            // console.log('## AuthUser ## r');
            // console.log('## AuthUser ## Signing in (STEP 3 - received token)', getUserTokenData.login.token);
            if (getUserTokenData && getUserTokenData.login) {
                globalPersistentActions.setToken(getUserTokenData.login.token);
                if (inPopup) {
                    const popupParent = localStorage.getItem(popupParentKey);
                    // console.log('## AuthUser ## Signing in (STEP 3 - sending token to popup)');
                    tellParentURLMessage({
                        action: 'auth-token',
                        token: getUserTokenData.login.token
                    }, JSON.parse(popupParent))
                }
            }
        }
    }, [getUserTokenData, globalPersistentState.authUser, globalPersistentState.state]);

    // Signing in (STEP 4) get or create the user
    useEffect(() => {
        if (globalPersistentState.state === STATES.LOGGING_IN && globalPersistentState.authUser && globalPersistentState.token && !globalPersistentState.me) {
            // console.log('## AuthUser ## s');
            // console.log('## AuthUser ## Signing in (STEP 4 - retrieving user)', globalPersistentState.authUser.uid);
            getUserRefetch().then(function (result) {
                if (result.data && result.data.user && result.data.user.userId) {
                    console.log('## AuthUser ## &&&&&&&& found a user', result.data.user);
                    globalPersistentActions.setMe(result.data.user);
                } else {
                    console.log('## AuthUser ## did NOT find a user', result);

                    // console.log('## AuthUser ## does authUser have fname?', globalPersistentState.authUser);
                    let firstName = globalPersistentState.firstName ? globalPersistentState.firstName : '';
                    let lastName = globalPersistentState.lastName ? globalPersistentState.lastName : '';
                    let displayName = firstName + ' ' + lastName;
                    if (globalPersistentState.authUser.displayName) {
                        displayName = globalPersistentState.authUser.displayName;
                        const name = parseFullName(displayName);
                        firstName = name.first;
                        lastName = name.last;
                    }

                    // console.log('## AuthUser ## creating a user', displayName);
                    createUser({
                        variables: {
                            newUser: {
                                userId: globalPersistentState.authUser.uid,
                                email: globalPersistentState.authUser.email,
                                displayName: displayName,
                                firstName: firstName,
                                lastName: lastName,
                                phoneNumber: globalPersistentState.authUser.phoneNumber,
                                photoUrl: globalPersistentState.authUser.photoUrl,
                                providerId: globalPersistentState.authUser.providerId,
                            }
                        }
                    }).then(result => {
                        // console.log('## AuthUser ## created a user', result.data);
                        globalPersistentActions.setMe(result.data.createUser);
                        globalPersistentActions.setState(STATES.LOGGED_IN_UNVERIFIED);
                    }).catch(e => {
                        // console.log('## AuthUser ## some nasty problem', e.message);
                        console.trace(e);
                    })
                }
            })
        }
    }, [globalPersistentState.token, createUser, globalPersistentState.state, globalPersistentState.authUser, globalPersistentState.me, getUserRefetch, globalPersistentState.firstName, globalPersistentState.lastName]);

    // Signing in (STEP 5) now all set up
    useEffect(() => {
        const saveMessage = (msg) => {
            // if (msg.person) {
            //     savePerson({variables: {person: msg.person}})
            // } else if (msg.organization) {
            //     saveOrganization({variables: {organization: msg.organization}})
            // }
        };

        if (globalPersistentState.state === STATES.LOGGING_IN && globalPersistentState.authUser && globalPersistentState.token && globalPersistentState.me) {
            // console.log('## AuthUser ## t');
            // console.log('## AuthUser ## Signing in (STEP 5) - setting state to', STATES.LOGGED_IN);
            if (globalPersistentState.me.verified) {
                globalPersistentActions.setState(STATES.LOGGED_IN);
                if (inPopup) {
                    const popupParent = localStorage.getItem(popupParentKey);
                    tellParentURLMessage({action: 'signed-in'}, JSON.parse(popupParent))

                    // window.parent.postMessage({action: 'signed-in'}, JSON.parse(popupParent));
                    getUserPreferencesRefetch().then(getUserPreferencesResult => {
                        tellParentURLMessage({userPreferences: getUserPreferencesResult.data.userPreferences}, JSON.parse(popupParent))
                        tellParentURLMessage({action: 'close-window'}, JSON.parse(popupParent))
                        // window.parent.postMessage({action: 'close-window'}, JSON.parse(popupParent));
                        globalPersistentActions.closePopup();
                        localStorage.setItem(popupParentKey, null);
                    }).catch(e => {
                        console.trace(e);
                        tellParentURLMessage({action: 'close-window'}, JSON.parse(popupParent))
                        // window.parent.postMessage({action: 'close-window'}, JSON.parse(popupParent));
                        globalPersistentActions.closePopup();
                        localStorage.setItem(popupParentKey, null);
                    });
                } else {
                    if (globalPersistentState.message) {
                        // console.log('## AuthUser ## Signing in (STEP 5) - found message');
                        saveMessage(globalPersistentState.message);
                    } else {
                        // console.log('## AuthUser ## Signing in (STEP 5) - no message... to the dashboard!', globalPersistentState.me.userId);
                        if (!globalPersistentState.me.verified) {

                        }
                        const redirectPage = localStorage.getItem(redirectPageKey);
                        // if (inIFrame) {
                        //     // if (globalPersistentState.contact) {
                        //     //     console.log('## AuthUser ## history.push 2', ROUTES.CONTACTS + '/' + globalPersistentState.contact.contactId);
                        //     //     history.push(ROUTES.CONTACTS + '/' + globalPersistentState.contact.contactId);
                        //     // } else if (globalPersistentState.account) {
                        //     //     console.log('## AuthUser ## history.push 3', ROUTES.ACCOUNTS + '/' + globalPersistentState.account.accountId);
                        //     //     history.push(ROUTES.ACCOUNTS + '/' + globalPersistentState.account.accountId);
                        //     // } else {
                        //     //     console.log('## AuthUser ## history.push 4', ROUTES.IFRAME_WAITING);
                        //     //     history.push(ROUTES.IFRAME_WAITING);
                        //     // }
                        // } else {
                        if (redirectPage) {
                            localStorage.setItem(redirectPageKey, null);
                            // console.log('## AuthUser ## redirecting to ', JSON.parse(redirectPage));
                            history.push(JSON.parse(redirectPage));
                        } else if (globalPersistentState.popupQueryObj) {
                            // console.log('## AuthUser ## FOUND QUERYOBJ', globalPersistentState.popupQueryObj);
                            globalPersistentActions.closePopup();
                        } else {
                            // console.log('## AuthUser ## DID NOT FIND QUERYOBJ', globalPersistentState.popupQueryObj);
                            history.push('/dashboard');
                        }
                        // }
                    }
                }
            } else {
                // console.log('## AuthUser ## Signing in (STEP 5) - setting state to', STATES.LOGGED_IN_UNVERIFIED);
                globalPersistentActions.setState(STATES.LOGGED_IN_UNVERIFIED);
                if (document.location.pathname.indexOf('/verify-email') === -1) {
                    // console.log('## AuthUser ## changing history', '/verify-email');
                    history.push('/verify-email');
                }
            }
        }
    }, [globalPersistentState.me, globalPersistentState.authUser, globalPersistentState.message, globalPersistentState.state, globalPersistentState.token]);

    // ############### SIGNING OUT ###############

    useEffect(() => {
        if (globalPersistentState.state === STATES.LOGGING_OUT && !globalPersistentState.me && !globalPersistentState.authUser && !globalPersistentState.token) {
            // console.log('## AuthUser ## u');
            // console.log('## AuthUser ## logging out - clearing state');

            globalPersistentActions.setState(STATES.LOGGED_OUT);

            const okPages = ['/sign-in', '/sign-up', '/forgot-password', '/network-error', '/verify-email', '/loading'];
            const index = okPages.indexOf(document.location.pathname);
            if (index > -1) {
                // console.log('## AuthUser ## where you need to be', document.location.pathname);
            } else {
                // console.log('## AuthUser ## changing history', '/sign-in');
                history.push('/sign-in');
            }
        }
    }, [globalPersistentState.state, globalPersistentState.me, globalPersistentState.authUser, globalPersistentState.token]);

    useEffect(() => {
        if (globalPersistentState.state === STATES.LOGGING_OUT && globalPersistentState.me) {
            // console.log('## AuthUser ## v');
            // console.log('## AuthUser ## logging out - clearing user');
            globalPersistentActions.setMe();
        }
    }, [globalPersistentState.state, globalPersistentState.me]);

    useEffect(() => {
        if (globalPersistentState.state === STATES.LOGGING_OUT && globalPersistentState.authUser) {
            // console.log('## AuthUser ## w');
            // console.log('## AuthUser ## logging out - clearing auth user');
            globalPersistentActions.setAuthUser(null);
        }
    }, [globalPersistentState.state, globalPersistentState.authUser]);

    useEffect(() => {
        if (globalPersistentState.state === STATES.LOGGING_OUT && globalPersistentState.token) {
            // console.log('## AuthUser ## x');
            // console.log('## AuthUser ## logging out - clearing token');
            globalPersistentActions.setToken(null);
        }
    }, [globalPersistentState.state, globalPersistentState.token]);

    // ############### SOME OTHER PROBLEM ###############
    useEffect(() => {
        if (globalPersistentState.state === STATES.LOGGED_OUT) {
            // console.log('## AuthUser ## y', window.location.search);
            const okPages = ['/sign-in', '/sign-up', '/forgot-password', '/network-error', '/verify-email', '/loading'];
            const index = okPages.indexOf(document.location.pathname);
            if (index > -1) {
                // console.log('## AuthUser ## where you need to be', document.location.pathname);
            } else {
                // console.log('## AuthUser ## changing history', '/sign-in');
                history.push('/sign-in');
            }
        }
    });

    // ############### In Iframe ###############
    useEffect(() => {
        if (globalPersistentState.state === STATES.LOGGED_IN && inIFrame) {
            // console.log('## AuthUser ## Logged In and in iFrame');
            const okPages = ['/contacts', '/accounts', '/loading', '/network-error', '/verify-email', '/popup', '/sign-in', '/sign-up'];
            let ok = false;
            for (let o = 0; o < okPages.length; o++) {
                const okPage = okPages[o];
                if (document.location.pathname.indexOf(okPage) > -1) ok = true;
            }
            if (ok) {
                // console.log('## AuthUser ## where you need to be', document.location.pathname);
            } else {
                // console.log('## AuthUser ## not where you need to be', document.location.pathname);
                const popupParent = localStorage.getItem(popupParentKey);
                if (popupParent) {
                    // console.log('## AuthUser ## cleaning up popup cause you are not where you need to be', JSON.parse(popupParent));
                    // getUserPreferencesRefetch();
                    tellParentURLMessage({action: 'close-window'}, JSON.parse(popupParent))
                    // window.parent.postMessage({action: 'close-window'}, JSON.parse(popupParent));
                    globalPersistentActions.closePopup();
                    localStorage.setItem(popupParentKey, null);
                } else {
                    // console.log('## AuthUser ## did not find localStorage:' + popupParentKey);
                }
                // if (globalPersistentState.contact) {
                //     console.log('## AuthUser ## history.push 8', ROUTES.CONTACTS + '/' + globalPersistentState.contact.contactId);
                //     history.push(ROUTES.CONTACTS + '/' + globalPersistentState.contact.contactId)
                // } else if (globalPersistentState.account) {
                //     console.log('## AuthUser ## history.push 9', ROUTES.ACCOUNTS + '/' + globalPersistentState.account.accountId);
                //     history.push(ROUTES.ACCOUNTS + '/' + globalPersistentState.account.accountId)
                // } else {
                //     console.log('## AuthUser ## history.push 10', ROUTES.IFRAME_WAITING);
                //     history.push(ROUTES.IFRAME_WAITING);
                // }
            }
        }
    });

    return (
        <>
        </>
    )
};

export default AuthUser;
